export const viewport = () => {
    var e = window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return {width: e[a + 'Width'], height: e[a + 'Height']};
};

export const closest = (elem, selector) => {
    while (elem) {
        if (elem.matches(selector)) {
            return elem;
        } else {
            elem = elem.parentElement;
        }
    }
    return null;
};

export const getBlogId = () => {
    return isBlogId(1) ? 1 : 2;
}

export const isBlogId = (id) => {
    return document.body.classList.contains(`blog-id-${id}`);
}

export const navText = (color) => {
    return [
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7 13L1 7L7 1" stroke="' + color + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>',
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 13L7 7L1 1" stroke="' + color + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>'
    ];
}

export const addPhoneHiddenInpits = (iti, phoneInput, codeInputName, fullInputName) => {
    // Function to append hidden inputs
    function appendHiddenInputs() {
    let codeInput = document.getElementById(codeInputName);
    let fullInput = document.getElementById(fullInputName);

    if (!codeInput) {
        codeInput = document.createElement("input");
        codeInput.type = "hidden";
        codeInput.id = codeInputName;
        codeInput.name = codeInputName;
        phoneInput.insertAdjacentElement("afterend", codeInput);
    }

    if (!fullInput) {
        fullInput = document.createElement("input");
        fullInput.type = "hidden";
        fullInput.id = fullInputName;
        fullInput.name = fullInputName;
        codeInput.insertAdjacentElement("afterend", fullInput);
    }

    codeInput.value = iti.getSelectedCountryData().dialCode;
    fullInput.value = iti.getNumber();
    }

    // Update hidden inputs on modification
    phoneInput.addEventListener("input", appendHiddenInputs);
    phoneInput.addEventListener("countrychange", appendHiddenInputs);
    phoneInput.addEventListener("open", appendHiddenInputs); // This requires custom event triggering

    // Append hidden inputs initially
    appendHiddenInputs();
}

export const getRowsHeight = ($grid, rowCount) => {
    const $items = $grid.children();
    if ($items.length === 0 || rowCount <= 0) return 0;

    const rowGap = parseFloat($grid.css('row-gap')) || 0;

    // Collect unique top positions of all items (each top = start of a row)
    const rows = {};
    $items.each(function() {
        const top = $(this).position().top;
        if (!rows[top]) rows[top] = [];
        rows[top].push(this);
    });

    // Get row tops sorted ascending
    const sortedTops = Object.keys(rows).map(Number).sort((a, b) => a - b);

    // Limit rowCount to actual number of rows
    const rowsToCount = sortedTops.slice(0, rowCount);

    // Sum max height of each row + row gaps
    let totalHeight = 0;
    rowsToCount.forEach((top, index) => {
        const $rowItems = $(rows[top]);
        const maxRowHeight = Math.max(...$rowItems.map(function() {
            return $(this).outerHeight();
        }).get());

        totalHeight += maxRowHeight;

        // Add row gap except after the last row
        if (index < rowsToCount.length - 1) {
            totalHeight += rowGap;
        }
    });

    return totalHeight;
};

